import React from 'react'
import './index.scss'
import FUIcon from '../Common/FUIcon'
import { NAVIGATOR, PUBLIC_PATH } from '@/App'
import { NavLink, Routes, Route } from "react-router-dom";

const NaviComp = (props) => {
    const { style } = props
    return (
        <div style={style} className="navi-page">
            <header className='navi-header'>
                <FUIcon
                    size="28px"
                    name='slices/icon_logo_avatar1.png'
                    style={{ marginRight: '10px' }}
                />
                <img src={require('@/assets/slices/logo_avatar.png')} alt="" />
            </header>
            {
                NAVIGATOR.map(group => (
                    <section key={group.title} className="navi-group">
                        <p className='title'>
                            {group.title}
                        </p>
                        <div className='navi-item-list'>
                            {
                                group.children.map(item => (
                                    <NavLink
                                        key={item.key}
                                        className="navi-item"
                                        to={item.key}
                                        state={{
                                            key: item.key
                                        }}
                                    >
                                        <div style={{ marginRight: '24px' }}>
                                            {item.icon}
                                        </div>
                                        <div style={{ flexGrow: '1' }}>
                                            <p className='navi-item-title'>{item.title}</p>
                                            <p className='navi-item-description'>{item.description}</p>
                                        </div>
                                        <FUIcon
                                            className="arrow-icon"
                                            size="48px"
                                            name='slices/icon_forword_nor.png'
                                        />
                                    </NavLink>
                                ))
                            }
                        </div>
                    </section>
                ))
            }
        </div>
    )
}

export default NaviComp
